// extracted by mini-css-extract-plugin
export var bodySections = "_do-8";
export var gray = "_do-7";
export var green = "_do-4";
export var iconContainer = "_do-9";
export var iconWidgetContainer = "_do-1";
export var phoneIcon = "_do-2";
export var red = "_do-5";
export var statusDot = "_do-3";
export var widgetContainer = "_do-0";
export var yellow = "_do-6";